import {SizeSelection_Size} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/size_selection.types';
import {useTranslation} from '@aboutyou/i18n';
import {Button} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {useMemo} from 'react';

interface AddToBasketAndWishlistButtonsProps {
  handleAddToBasket: (captchaCode?: string) => Promise<boolean | void>;
  inlineSizeSelection: boolean;
  isAddToBasketDisabled?: boolean;
  isInBasket: (sizeId?: number | undefined) => boolean;
  isProcessing: boolean;
  size?: SizeSelection_Size;
  wishlistComponent?: React.ReactNode;
}

export const AddToBasketAndWishlistButtons: React.FC<
  AddToBasketAndWishlistButtonsProps
> = ({
  handleAddToBasket,
  inlineSizeSelection,
  isAddToBasketDisabled,
  isInBasket,
  isProcessing,
  size,
  wishlistComponent,
}) => {
  const {t} = useTranslation();

  const label = useMemo(() => {
    const defaultCta = t(`Add to basket`);

    if (isInBasket(size?.sizeId)) {
      return t('Already in basket');
    } else {
      return defaultCta;
    }
  }, [isInBasket, size, t]);

  const addToBasketButtonDataTestid = 'addToBasketButton';

  return (
    <WrapperAddToBasketAndWishlistButtons
      $inlineSizeSelection={inlineSizeSelection}
    >
      <StyledButton
        disabled={isAddToBasketDisabled}
        isLoading={isProcessing}
        onClick={() => {
          handleAddToBasket();
        }}
        data-testid={addToBasketButtonDataTestid}
        aria-label={undefined}
        variant="primary"
        size="full-width"
      >
        {label}
      </StyledButton>
      {wishlistComponent}
    </WrapperAddToBasketAndWishlistButtons>
  );
};

const StyledButton = styled(Button)`
  &&& {
    margin-top: 0.5rem;
  }
`;

const WrapperAddToBasketAndWishlistButtons = styled.div<{
  $inlineSizeSelection: boolean;
}>`
  display: flex;
  flex: 1 1 100%;
  flex-direction: row;
  align-items: end;

  margin-top: ${({$inlineSizeSelection}) =>
    $inlineSizeSelection ? '22px' : '1rem'};
`;
